import React from "react";

export default function PortionCard({ portion: { title, body, id }, setLoteamiento, position }) {
  return (
    <div onClick={() => setLoteamiento(id)} className={`home-loteamiento shadow1 home-loteamiento-${position}`}>
      <div className="home-loteamiento-title">{title}</div>
      <div className="home-loteamiento-body">{body}</div>
    </div>
  );
}
